<template>
  <el-card class="page-deptCode">
    <div style="display: flex;margin-bottom: 15px;flex-direction: row;align-items: center;justify-content: space-between">
      <div style="display: flex;flex:1;">
        <el-input v-model="name" placeholder="请输入二维码名称" style="max-width: 350px" @keyup.enter.native="getQueryList"/>
        <el-button type="primary" round style="margin-left: 30px" @click="getQueryList">搜索</el-button>
      </div>
      <div>
        <el-button type="danger" round :loading="removeLoading" @click="remove">删除</el-button>
        <el-button type="primary" round @click="add">创建二维码</el-button>
      </div>
    </div>
    <Table ref="tableRef" :columns="columns" :data="dataSource" :loading="loading">

      <!-- <code-canvas v-if="row.url && !loading" :id="row.id" :url="row.url" :name="row.name" /> -->
      <template slot-scope="{ row }" slot="action">
        <el-button type="text" style="margin-right: 10px" @click="edit(row)">编辑</el-button>
        <el-button type="text" @click="download(row)">下载</el-button>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <el-dialog :title="form.id ? '编辑二维码' : '新增二维码'" center :append-to-body="true" :visible="show" :close-on-click-modal="false" :destroy-on-close="true" width="600px" @close="cancel">
      <el-form ref="formRef" :rules="rules" :model="form" label-width="95px">
        <el-form-item label="二维码名称" prop="name">
          <div style="display:flex">
            <el-input v-model="form.name" placeholder="请输入二维码名称" style="margin-right: 30px" />
            <el-button size="small" round @click="showQuesModal">新增关联问卷</el-button>
          </div>
        </el-form-item>
        <Table :columns="formColumns" :data="form.relations">
          <template slot-scope="{ row }" slot="action">
            <el-button type="text" style="margin-right: 10px;color: #f56c6c;" @click="removeRelatioin(row)">删除</el-button>
          </template>
        </Table>
      </el-form>
      <div slot="footer">
        <el-button type="info" round @click="cancel">取消</el-button>
        <el-button type="primary" round :loading="modalLoading" @click="submit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="问卷库" center :append-to-body="true" :visible="show_ques" :close-on-click-modal="false" :destroy-on-close="true" width="80%" @close="cancelQues">
      <choose-mini-ques
        :style="{'max-height': (windowHeight - 80 * 3 ) + 'px'}"
        style="overflow-y: auto;"
        @selectionData="handleSelect"
        @isModal="hideModal" />
        <div slot="footer">
          <el-button type="info" round @click="cancelQues">取消</el-button>
          <el-button type="primary" round @click="confirmQues">确定</el-button>
        </div>
    </el-dialog>
  </el-card>
</template>
<script>
import QRCode from 'qrcode'
import { getQrCodeListApi, updateQrCodeApi, removeQrCodeApi } from "../../api/deptCode"
import { formatDate } from '../../utils/date'
import chooseMiniQues from "./components/chooseMiniQues.vue"
import codeCanvas from "./components/codeCanvas.vue"
const dl = function(name, url) {
  const oA = document.createElement('a');
  oA.download = name + formatDate(new Date(), 0, 'yyyy-MM-dd hh:mm:ss');
  oA.href = url;
  document.body.appendChild(oA);
  oA.click();
  oA.remove();
}
export default {
  components: {
    chooseMiniQues,
    codeCanvas
  },
  data() {
    return {
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '二维码名称',
          align: 'center',
          key: 'name',
        },
        {
          title: '关联团队',
          align: 'center',
          key: 'relation_team_num',
        },
        {
          title: '关联问卷',
          align: 'center',
          key: 'relation_questionnaire_num',
        },
        {
          title: '创建人',
          align: 'center',
          key: 'create_user_name',
        },
        {
          title: '创建时间',
          align: 'center',
          key: 'create_time',
          width: '120'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          minWidth: 60
        },
      ],
      formColumns: [
        {
          title: '分类名称',
          key: 'category_name',
          align: 'center',
        },
        {
          title: '团队名称',
          key: 'team_name',
          align: 'center',
        },
        {
          title: '问卷名称',
          key: 'questionnaire_name',
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          slot: 'action',
          align: 'center',
        },
      ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入二维码名称",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入二维码名称",
            trigger: "change",
          },
        ]
      },
      name: '',
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      sizes: [10, 20, 30, 40, 50],
      dataSource: [],
      show: false,
      show_ques: false,
      modalLoading: false,
      selection: [],
      windowHeight: 0,
      form: {
        name: "",
        relations: []
      },
      removeLoading: false
    }
  },
  created() {
    this.getList();
    this.windowHeight = window.innerHeight
  },
  methods: {
    onCurrentChange(current) {
      this.page = current;
      this.getList();
    },
    onSizeChange(size) {
      this.size = size;
      this.getList();
    },
    getQueryList() {
      this.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      const { page, size, name } = this
      getQrCodeListApi({ page, size, name }).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.dataSource = res.data;
          this.total = res['x-total-count'] || res.data.length;
          if (this.total && !this.dataSource.length && this.page > 1) {
            this.page = this.page - 1
            this.getList()
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submit() {
      this.$refs.formRef.validate((vaild) => {
        if (vaild) {
          if (!this.form.relations.length) {
            this.$message.warning("请至少选择一项关联问卷");
          }
          this.modalLoading = true;
          updateQrCodeApi(this.form).then(res => {
            this.modalLoading = false
            if (res.code === 0) {
              this.show = false;
              this.$message.success("保存科室二维码成功！");
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          }).catch(() => {
            this.modalLoading = false;
          })
        }
      })
    },
    cancel() {
      this.form = {
        name: "",
        relations: []
      }
      this.show = false
    },
    download(row) {
      const canvas = document.createElement('canvas');
      // QRCode.toDataURL(row.url, {
      //   errorCorrectionLevel: 'H',
      //   type: 'image/jpeg',
      //   quality: 0.8,
      //   margin: 1,
      // }, (err, url) => {
      //   if (err) throw err
      //   const img = new Image();
      //   img.src = url;
      //   canvas.height = 480;
      //   canvas.width = 480;
      //   ctx.fillStyle = "#fff";
      //   ctx.fillRect(0, 0, 480, 480);
      //   ctx.drawImage(img, 40, 40, 400, 400);
      // });
      QRCode.toCanvas(canvas, row.url, {
        width: 400,
        height: 400,
        errorCorrectionLevel: 'H',
      }, (error) => {
        if (error) {
          this.$message.error("绘制图片失败，请重新尝试！")
          return;
        }
        dl(row.name, canvas.toDataURL("image/png"));
      })

    },
    edit(row) {
      this.show = true
      this.form = JSON.parse(JSON.stringify(row));
    },
    add() {
      this.show = true;
    },
    remove() {
      const arr = this.$refs.tableRef.getSelection();
      if (!arr.length) {
        this.$message.warning('请至少选择一项要删除！')
      }
      this.removeLoading = true;
      removeQrCodeApi({ids: arr.map(a => a.id)}).then(res => {
        this.removeLoading = false
        if(res.code === 0) {
          this.$message.success('删除成功！');
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        this.removeLoading = false;
      })
    },
    showQuesModal() {
      this.show_ques = true
    },
    cancelQues() {
      this.selection = [];
      this.show_ques = false
    },
    confirmQues() {
      if (this.selection.length == 0) {
        this.$Message.warning('请选择问卷')
        return
      }
      this.show_ques = false;
      this.form.relations = this.form.relations.concat(this.selection.filter(s => !this.form.relations.find(r => r.questionnaire_no == s.questionnaire_no)))
    },
    removeRelatioin(row) {
      this.form.relations = this.form.relations.filter(r => r.questionnaire_no !== row.questionnaire_no);
    },
    handleSelect(data) {
      this.selection = data;
    },
    hideModal() {
      this.cancelQues();
      this.cancel();
    }
  }
}
</script>
